export default {
  loaded: false
}